import { isProductVitamin } from '@src/quince-site-common/src/helpers/productHelper'

import { formatDisclaimerText } from './disclaimer.helper'
import * as styles from './disclaimer.module.scss'

const Disclaimer = (props: any) => {
  const product = 'bundle' in props ? props.bundle : props.product
  return (
    isProductVitamin(product) &&
    product?.disclaimer && (
      <div
        className={styles.disclaimerBox}
        dangerouslySetInnerHTML={{
          __html: formatDisclaimerText(product?.disclaimer)!,
        }}
      />
    )
  )
}

export default Disclaimer
